<template>
  <defs>
    <marker id="editor-arrowhead" markerWidth="8" markerHeight="6" refX="7" refY="3" orient="auto">
      <polygon points="0 0, 8 3, 0 6" class="arrowhead" />
    </marker>
  </defs>
</template>

<style scoped>
.arrowhead {
  fill: #374151;
  opacity: 0.8;
}
</style>
